import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { SlocPage } from "@/features/stores/components/sloc-page";

export const Route = createFileRoute("/_app/stores/sloc/new")({
  beforeLoad: () => {
    if (!useAuth.getState().can("stores.sloc"))
      throw redirect({ to: "/stores/sloc" });
  },
  component: Page,
});

function Page() {
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  return (
    <SlocPage
      doc={null}
      facilityId={selected?.id}
      plantName={selected ? `${selected.name} (${selected.plantCode})` : null}
    />
  );
}
